export const report = {
  namespaced: true,
  namespace: 'report',
  state: {
    createType: 'create',
    reportDetail: {},
    assignList: []
  },
  getters: {
    createType: state => {
      return state.createType;
    },
    gettersReportDetail: state => {
      return state.reportDetail;
    },
    assignList: state => {
      return state.assignList;
    }
  },
  mutations: {
    setCreateType(state, createType) {
      state.createType = createType;
    },
    setReportDetail(state, reportDetail) {
      state.reportDetail = reportDetail;
    },
    setAssignList(state, assignList) {
      state.assignList = assignList;
    }
  }
};
